import BgUrl from '@assets/images/home-bg.png'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-image: url(${BgUrl});
  background-size: cover;
  background-position: center;

  form {
    width: 100%;
    max-width: 400px;
    background-color: #fff;
    padding: 20px;
    border-radius: 2px;
    box-shadow: 0px 2px 8px 0 rgb(29 35 41 / 5%);

    .ant-alert {
      margin-bottom: 12px;
    }

    .ant-typography,
    .signup {
      text-align: center;
    }

    .forgot-password {
      margin-bottom: 24px;
      text-align: right;
    }

    .ant-btn {
      width: 100%;
    }
  }
`
